module.exports = __webpack_public_path__ + "static/media/port-online.8b98c8dd.png";